import { FunctionalComponent, h } from '@stencil/core';
import dayjs from 'dayjs'
import { AppMedia, AppRTE, SectionFullGallery } from '.'


interface SectionArticle {
    data?: any;
}


export const SectionArticle: FunctionalComponent<SectionArticle> = ({ data }) => {

    const { Body, Date, Title, Media, Gallery } = data

    const gallery = { Items: Gallery }

    // Specification.News = News
    console.log('article', data)
    return [
        <section class="uk-light">
            <div class="uk-container uk-container-large">
                <div class="uk-background-muted-full uk-child-width-1-1 uk-child-width-1-2@s uk-grid-collapse uk-grid-match" uk-grid>
                    <div class="uk-height-min-large@s uk-first-column">
                        <div class="uk-position-relative uk-background-primary-diag uk-flex uk-flex-column">
                            <div class="uk-padding uk-padding-large@s uk-flex-1 uk-flex uk-flex-middle">
                                <div>
                                    <h4 class="uk-heading-small wsio-gold uk-margin-small-bottom">{dayjs(Date).format('dddd D MMMM YYYY')}</h4>
                                    <h1 class="uk-heading-large uk-margin-remove-top uk-text-uppercase">{Title}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uk-height-min-medium uk-cover-container">
                        <AppMedia media={Media} size="(max-width: 638px) 80vw, (max-width: 958px) 50vw, 30vw" cover eager />
                    </div>
                </div>
            </div>
        </section>
        ,
        <section class={`uk-section ${Gallery && Gallery.length > 0 ? 'uk-padding-remove-bottom' : ''}`}>
            <div class="uk-container">
                <AppRTE markdown={Body} />
            </div>
        </section>,
        Gallery && Gallery.length > 0 ? <SectionFullGallery data={gallery} /> : false
    ]
};